import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.to-fixed.js";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@emotion/react';
import { Paper } from 'components/UI';
import EChart from '../shared/EChart';
import { jsx as ___EmotionJSX } from "@emotion/react";

var GivenAmountsChart = function GivenAmountsChart(_ref) {
  var givenByMonth = _ref.givenByMonth,
      _ref$currency = _ref.currency,
      currency = _ref$currency === void 0 ? 'EUR' : _ref$currency;
  var theme = useTheme();
  var option = useMemo(function () {
    if (!(givenByMonth !== null && givenByMonth !== void 0 && givenByMonth.length)) return null;
    var months = givenByMonth.map(function (m) {
      return m.month;
    });
    var amounts = givenByMonth.map(function (m) {
      var _m$total;

      return Number((_m$total = m.total) !== null && _m$total !== void 0 ? _m$total : 0);
    });
    var counts = givenByMonth.map(function (m) {
      var _m$count;

      return (_m$count = m.count) !== null && _m$count !== void 0 ? _m$count : 0;
    });
    return {
      tooltip: {
        trigger: 'axis',
        formatter: function formatter(params) {
          var idx = params[0].dataIndex;
          return "".concat(months[idx], "<br/>\u0421\u0443\u043C\u0430: ").concat(amounts[idx].toFixed(2), " ").concat(currency, "<br/>\u0411\u0440\u043E\u0439: ").concat(counts[idx]);
        }
      },
      grid: {
        left: 10,
        right: 10,
        top: 20,
        bottom: 30,
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: months,
        axisLabel: {
          color: theme.gray400,
          fontSize: 11
        },
        axisLine: {
          lineStyle: {
            color: theme.gray200
          }
        }
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          color: theme.gray400,
          fontSize: 11
        },
        splitLine: {
          lineStyle: {
            color: theme.gray100
          }
        }
      },
      series: [{
        type: 'bar',
        data: amounts,
        itemStyle: {
          color: theme.primary
        },
        barWidth: '50%'
      }]
    };
  }, [givenByMonth, theme, currency]);
  return ___EmotionJSX(Paper, {
    header: "\u0420\u0430\u0437\u0434\u0430\u0434\u0435\u043D\u0438 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430 (6 \u043C\u0435\u0441.)",
    noPadding: true,
    padding: "1em"
  }, ___EmotionJSX(EChart, {
    option: option,
    height: 260
  }));
};

GivenAmountsChart.propTypes = {
  givenByMonth: PropTypes.array,
  currency: PropTypes.string
};
export default GivenAmountsChart;